const PORTAL_ROOT_ID = 'modal-root';

/**
 * Resolves the shared container that modals and drawers portal into.
 *
 * Callers must resolve this once per component instance (e.g. a lazy `useState` initializer) and
 * reuse it for the component's lifetime. Handing `createPortal` a different container between
 * renders makes React tear down and rebuild the whole portal subtree, which flashes the overlay,
 * replays its open animation, and drops focus out of whatever field the user is typing in.
 *
 * The element is declared in index.html so it already exists on the first render; it is created
 * here as a fallback for hosts that do not provide it.
 */
export const getPortalRoot = (): HTMLElement => {
    const existingRoot = document.getElementById(PORTAL_ROOT_ID);

    if (existingRoot) return existingRoot;

    const createdRoot = document.createElement('div');

    createdRoot.id = PORTAL_ROOT_ID;
    document.body.appendChild(createdRoot);

    return createdRoot;
};
